import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import spinner from "../../../assets/iconos/spinner4.svg";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { useTranslation } from "react-i18next";
import TimeZoneComponent from "../../../components/time-zone-component";
import { actualizarInfoEmpresa, } from "../../../api/api-empresa-plataforma";
import Select from "react-select";
// import SwitchComponent from "../../../components/switch-component";
// import LabelConSin from "../../../components/label-con-sin-periodo-prueba";
import { getListMoneda } from "../../../api/api-moneda";
import moment from "moment";

export default function EditarEmpresaPlataforma() {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [selectedHour, setSelectedHour] = useState("");
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [listaMoneda, setListaMoneda] = useState([]);
    // const [monedaSelected, setMonedaSelected] = useState(null);
    // const [periodoPrueba, setPeriodoPrueba] = useState(true);
    const [formData, setFormData] = useState({
        codigo: '',
        nombre: '',
        telefonoEmpresa: '',
        emailEmpresa: '',
        representante: '',
        telefonoRepresentante: '',
        emailRepresentante: '',
        timeZone: '',

        nombreEncargadoCobranza: '',
        cargoCobranza: '',
        telefonoCobranza: '',
        emailCobranza: '',

        // precioUnitarioVehiculo: '',
        diaFacturacion: '',
    });

    const charLimits = {
        codigo: 64,
        nombre: 128,
        telefonoEmpresa: 64,
        emailEmpresa: 64,
        representante: 128,
        telefonoRepresentante: 64,
        emailRepresentante: 64,
        timeZone: 8,

        nombreEncargadoCobranza: 128,
        cargoCobranza: 128,
        telefonoCobranza: 64,
        emailCobranza: 128,

        diaFacturacion: 2,
    };

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            if (data !== undefined && data !== null) {
                setFormData(data.params);
                setSelectedHour(data.params.timeZone);
            }
            // const response = await getListMoneda({}, true, null);
            // console.log('response');
            // console.log(response);
            // setListaMoneda(response);
            // if (data.params.idMoneda !== undefined && data.params.idMoneda !== null) {
            //     const moneda = response.find((item) => item.value === data.params.idMoneda);
            //     setMonedaSelected(moneda);
            // }
            // if (data.params.periodoPrueba !== undefined && data.params.periodoPrueba !== null) {
            //     setPeriodoPrueba(data.params.periodoPrueba);
            // }
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleChangeNumber = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const editAccount = async () => {
        // console.log('editAccount');
        // e.preventDefault();
        // lógica para guardar los cambios
        // console.log('formData');
        // console.log(formData);
        // const isValid = validar();
        // if (isValid.error === true) {
        //     alert(isValid.message);
        //     return;
        // }
        // return;
        let objEnviar = {};
        objEnviar.id = formData.id;
        objEnviar.codigo = formData.codigo;
        objEnviar.nombre = formData.nombre;
        objEnviar.telefonoEmpresa = formData.telefonoEmpresa;
        objEnviar.emailEmpresa = formData.emailEmpresa;

        // objEnviar.precioUnitarioVehiculo = formData.precioUnitarioVehiculo;
        // objEnviar.idMoneda = monedaSelected?.value;
        // objEnviar.diasPeriodoPrueba = formData.diasPeriodoPrueba;
        // objEnviar.periodoPrueba = periodoPrueba;

        objEnviar.nombreEncargadoCobranza = formData.nombreEncargadoCobranza;
        objEnviar.cargoCobranza = formData.cargoCobranza;
        objEnviar.telefonoCobranza = formData.telefonoCobranza;
        objEnviar.emailCobranza = formData.emailCobranza;
        objEnviar.diaFacturacion = formData.diaFacturacion;

        objEnviar.representante = formData.representante;
        objEnviar.telefonoRepresentante = formData.telefonoRepresentante;
        objEnviar.emailRepresentante = formData.emailRepresentante;
        objEnviar.timeZone = selectedHour;

        // console.log('objEnviar');
        // console.log(objEnviar);
        // return;
        if (objEnviar.id !== 0) {
            // console.log('actualizar correo');
            const response = await actualizarInfoEmpresa(objEnviar);
            // console.log('modificado');
            // console.log(modificado);
            if (response.error === false) {
                alert('Se proceso correctamente');
                handleAtrasClick();
            }
            if (response.error === true) {
                alert('No se pudo crear\n' + response.message);
            }
        }
    };

    const validar = () => {
        try {
            // console.log('validar');
            // console.log(formData);
            let result = { error: true, message: "" };
            let message = "";
            if (formData.nombre.trim().length === 0) {
                message = message + "Debe ingresar nombre empresa" + "\n";
            }
            if (formData.telefonoEmpresa.trim().length === 0) {
                message = message + "Debe ingresar telefono empresa" + '\n';
            }
            if (formData.emailEmpresa.trim().length === 0) {
                message = message + "Debe ingresar email empresa" + '\n';
            }
            if (String(selectedHour).trim().length === 0) {
                message = message + "Debe seleccionar timeZone" + '\n';
            }
            // if (formData.precioUnitarioVehiculo === undefined || String(formData.precioUnitarioVehiculo).trim().length === 0) {
            //     message = message + "Debe ingresar precio unitario vehiculo" + '\n';
            // }
            // if (monedaSelected === null || monedaSelected === undefined) {
            //     message = message + "Debe seleccionar moneda" + '\n';
            // }
            if (message.length > 0) {
                result.error = true;
                result.message = message;
            } else {
                result.error = false;
            }
            return result;
        } catch (err) {
            return { error: true, message: err };
        }
    };

    const handleNextStep = async (e) => {
        try {
            // console.log('handleNextStep');
            // console.log(formData);
            e.preventDefault();
            const isValid = validar();
            if (isValid.error === true) {
                alert(isValid.message);
                return;
            }
            if (isValid.error === false) {
                /*const validNombreEmpresa = await countNombreEmpresaPlataforma(formData);
                if (validNombreEmpresa.error === true) {
                    alert('No se pudo verificar nombre empresa');
                    return;
                }
                if (validNombreEmpresa.total > 0) {
                    alert('Nombre empresa ya existe');
                    return;
                }*/
                editAccount();
            } else {
                alert(isValid.message);
            }
            setLoading(false);
        } catch (err) {
            console.log('handleNextStep err');
            console.log(err);
            setLoading(false);
        }
    };

    const render = () => {
        // console.log('render correo');
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="min-h-screen bg-gray-100 flex  justify-center">
                    <div className="w-full bg-white rounded-lg shadow-md p-6">
                        <h2 className="text-2xl font-bold text-left text-[#0F3457] mb-6">{t("title_edit_company")}</h2>
                        {/* <form onSubmit={handleNextStep}> */}
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                    Codigo
                                </label>
                                <input
                                    type="text"
                                    id="codigo"
                                    name="codigo"
                                    value={formData.codigo}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Codigo"
                                    maxLength={charLimits.codigo}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                    Nombre<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre"
                                    maxLength={charLimits.nombre}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nitCompany">
                                    Telefono Empresa<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="telefonoEmpresa"
                                    name="telefonoEmpresa"
                                    value={formData.telefonoEmpresa}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Telefono Empresa"
                                    maxLength={charLimits.telefonoEmpresa}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoEmpresa.length}/{charLimits.telefonoEmpresa}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telephoneCompany">
                                    Email Empresa<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="emailEmpresa"
                                    name="emailEmpresa"
                                    value={formData.emailEmpresa}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Email Empresa"
                                    maxLength={charLimits.emailEmpresa}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.emailEmpresa.length}/{charLimits.emailEmpresa}</p>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                    Representante
                                </label>
                                <input
                                    type="text"
                                    id="representante"
                                    name="representante"
                                    value={formData.representante}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Representante Empresa"
                                    maxLength={charLimits.representante}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.representante.length}/{charLimits.representante}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                    Telefono Representante
                                </label>
                                <input
                                    type="text"
                                    id="telefonoRepresentante"
                                    name="telefonoRepresentante"
                                    value={formData.telefonoRepresentante}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Telefono Representante"
                                    maxLength={charLimits.telefonoRepresentante}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoRepresentante.length}/{charLimits.telefonoRepresentante}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="addressCompany">
                                    Email Representante
                                </label>
                                <input
                                    type="text"
                                    id="emailRepresentante"
                                    name="emailRepresentante"
                                    value={formData.emailRepresentante}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Email Representante"
                                    maxLength={charLimits.emailRepresentante}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.emailRepresentante.length}/{charLimits.emailRepresentante}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <TimeZoneComponent
                                    selectedHour={selectedHour}
                                    setSelectedHour={setSelectedHour}
                                />
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            {/* <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="precioUnitarioVehiculo">
                                    P/U Vehiculo<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="precioUnitarioVehiculo"
                                    name="precioUnitarioVehiculo"
                                    value={formData.precioUnitarioVehiculo}
                                    onChange={handleChangeNumber}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="P/U Vehiculo"
                                    min={1}
                                />
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="moneda">
                                    Moneda<span className="text-red-500">*</span>
                                </label>
                                <Select
                                    options={listaMoneda}
                                    isSearchable={true} // Boolean props should not be strings
                                    isClearable={true}
                                    value={monedaSelected}
                                    onChange={(event) => setMonedaSelected(event)}
                                    placeholder="Seleccione Moneda"
                                />
                            </div> */}
                            {/* <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <LabelConSin periodoPrueba={periodoPrueba} />
                                <div className="flex justify-between items-center">
                                    <input
                                        type="number"
                                        id="diasPeriodoPrueba"
                                        name="diasPeriodoPrueba"
                                        value={formData.diasPeriodoPrueba}
                                        onChange={handleChangeNumber}
                                        className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                        placeholder={periodoPrueba ? 'Con ' + "Dias Periodo Prueba" : 'Sin ' + "Dias Periodo Prueba"}
                                        min={1}
                                        disabled={!periodoPrueba}
                                    />
                                    <div className="w-[10px]"></div>
                                    <SwitchComponent isOn={periodoPrueba} handleToggle={() => {
                                        const periodo = !periodoPrueba;
                                        if (periodo === false) {
                                            formData.diasPeriodoPrueba = null;
                                        }
                                        setPeriodoPrueba(periodo);
                                    }} />
                                </div>
                            </div> */}
                            {/* <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="fechaExpiracion">
                                    {t("label_date_expired")}
                                </label>
                                <input
                                    type="text"
                                    id="fechaExpiracion"
                                    name="fechaExpiracion"
                                    value={moment(formData.fechaExpiracion).isValid() ? moment(formData.fechaExpiracion).format('YYYY-MM-DD') : ''}
                                    onChange={handleChangeNumber}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Fecha Expiracion"
                                    disabled={true}
                                />
                            </div> */}
                        </div>
                        <br />
                        <h3 className="text-[#0F3457] font-bold" >Datos Cobranza</h3>
                        <hr />
                        <br />
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nombreEncargadoCobranza">
                                    Nombre Encargado Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="nombreEncargadoCobranza"
                                    name="nombreEncargadoCobranza"
                                    value={formData.nombreEncargadoCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre Encargado"
                                    maxLength={charLimits.nombreEncargadoCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nombreEncargadoCobranza?.length}/{charLimits.nombreEncargadoCobranza}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="cargoCobranza">
                                    Cargo Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="cargoCobranza"
                                    name="cargoCobranza"
                                    value={formData.cargoCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Cargo Cobranza"
                                    maxLength={charLimits.cargoCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.cargoCobranza?.length}/{charLimits.cargoCobranza}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="telefonoCobranza">
                                    Telefono Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="telefonoCobranza"
                                    name="telefonoCobranza"
                                    value={formData.telefonoCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Telefono Cobranza"
                                    maxLength={charLimits.telefonoCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.telefonoCobranza?.length}/{charLimits.telefonoCobranza}</p>
                            </div>
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="emailCobranza">
                                    Email Cobranza
                                </label>
                                <input
                                    type="text"
                                    id="emailCobranza"
                                    name="emailCobranza"
                                    value={formData.emailCobranza}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Email Cobranza"
                                    maxLength={charLimits.emailCobranza}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.emailCobranza?.length}/{charLimits.emailCobranza}</p>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4">
                            <div class="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="diaFacturacion">
                                    Dia Facturacion
                                </label>
                                <input
                                    type="number"
                                    id="diaFacturacion"
                                    name="diaFacturacion"
                                    value={formData.diaFacturacion}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Dia Facturacion"
                                    maxLength={charLimits.diaFacturacion}
                                    min={1}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.diaFacturacion?.length}/{charLimits.diaFacturacion}</p>
                            </div>
                        </div>
                        <div className="flex justify-between items-center">
                            <p
                                onClick={handleAtrasClick}
                                className="text-center text-[#0F3457] mt-4 cursor-pointer hover:underline"
                            >
                                Atras
                            </p>
                            <div>
                                {loading === false &&
                                    <button
                                        onClick={handleNextStep}
                                        className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                    >
                                        Guardar
                                    </button>
                                }
                                {loading === true &&
                                    <button
                                        className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                                    >
                                        <img className="spinner" alt="spinner" src={spinner} />
                                    </button>

                                }
                            </div>
                        </div>

                        {/* </form> */}

                    </div>
                </div >
            );
        } catch (err) {
            console.log('Empresa render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
